import React from 'react';
import { Route } from 'react-router-dom';
import HomeHeaderSection from '../pages/home-header/HomeHeaderSection';
import ProtectedRoute from '../components/global/ProtectedRoute';

const homeHeaderRoutes = (
    <Route
        path="/home-header/section"
        element={
            <ProtectedRoute requiredPermission="settings.home-header.view">
                <HomeHeaderSection />
            </ProtectedRoute>
        }
    />
);

export default homeHeaderRoutes;
